<template>
  <div id="stripe" class="row">
    <div :class="{'col-md-6': !fullSize, 'col-md-12': fullSize}">
      <h2 v-if="!hideTitle">
        Payment
      </h2>

      <div v-if="storedPaymentMethods.length > 0" class="stored-cards-container">
        <stored-credit-card
          v-for="card in storedPaymentMethods"
          :key="card.stripe_payment_method_id"
          :class="card.brand"
          :expired="card.expired"
          :payment-method-id="card.stripe_payment_method_id"
          :active="card.stripe_payment_method_id === selectedPaymentMethod && !showForm && !card.expired"
          :last_4_digits="card.last4digits"
          :brand="card.brand"
          :exp_month="card.exp_month.toString()"
          :exp_year="card.exp_year.toString()"
          @select-card="selectCard($event)"
        />
        <new-credit-card
          :active="showForm"
          @show-form="showPaymentForm()"
        />
      </div>

      <form
        id="payment-form"
        class="tdesk-form"
        :style="{'display': showForm ? 'block' : 'none'}"
      >
        <div class="form-group">
          <div id="card-element" />
        </div>
        <div v-if="userIsPartner == 'true'" class="form-group checkbox" style="margin-top: 20px;">
          <input
            id="save_card"
            v-model="storePaymentMethod"
            type="checkbox"
            name="save_card"
          >
          <label for="save_card" style="margin-left: 7px;">
            Save this card for the partnership (and approved trainers) to use in
            future
          </label>
        </div>
      </form>

      <submit-button
        :disabled="!buttonEnabled"
        :price="price"
        :btn-class="paymentButtonClass"
        :show-back-button="showBackButton"
        @click="document.querySelector('button#submit').disabled = false"
        @go-back="$emit('go-back', true)"
      />
    </div>
    <div v-if="!hideSummary" class="col-md-6">
      <purchase-summary :items="purchaseSummary.items" :total-price="purchaseSummary.total" />
    </div>
  </div>
</template>

<script>
  /* global Stripe */
  import StoredCreditCard from "./payments/StoredCreditCard";
  import SubmitButton from "../../src/PaymentApp/PaymentButton";
  import PurchaseSummary from "../../src/PaymentApp/PurchaseSummary";
  import NewCreditCard from "./payments/NewCreditCard";

  export default {
    components: {StoredCreditCard, NewCreditCard, SubmitButton, PurchaseSummary},
    props: {
      apiKey: { required: true, type: String },
      fullSize: { type: Boolean, default: false },
      hideSummary: { required: false, type: Boolean },
      hideTitle: { type: Boolean, default: false },
      maxAttempts: { required: false, default: 30, type: Number },
      paymentButtonClass: { type: String, required: false, default: undefined },
      paymentIntentCreatePath: { required: true, type: String },
      price: {required: true, type: String},
      purchaseParams: { required: true, type: Object },
      purchaseSummary: { required: false, type: Object, default: () => undefined },
      redirectPath: { required: false, type: String, default: undefined },
      showBackButton: { type: Boolean, default: false },
      storedPaymentMethods: { required: true, type: Array },
      stripeAccountId: { type: String, required: false, default: undefined },
      userIsPartner: { type: String, required: true },
    },
    data() {
      return {
        showForm: false,
        buttonEnabled: false,
        cardElement: null,
        storePaymentMethod: false,
        elementsContainerStyle: {
          base: {
            color: '#32325d',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#aab7c4',
            },
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
          },
        },
        attempts: 0,
        client: null,
        selectedPaymentMethod: null,
      };
    },
    created() {
      let stripe = Stripe(this.apiKey, { stripeAccount: this.stripeAccountId });
      let self = this;

      axios
          .post(
              this.paymentIntentCreatePath,
              this.purchaseParams,
          )
          .then(function (response) {
            self.client = response.data.clientSecret;
            let elements = stripe.elements();

            let card = elements.create("card", {
              style: self.elementsContainerStyle,
              hidePostalCode: true,
            });

            self.cardElement = card;

            card.mount("#card-element");

            let paymentMethodInput = document.getElementById('provider');

            if (paymentMethodInput !== null) {
              paymentMethodInput.addEventListener('change', function (ev) {
                self.showForm = ev.target.value === 'credit-card';
              });
            } else {
              self.showForm = true;
            }

            card.on("change", function (event) {
              let errorText = document.getElementById('error-text');

              if (event.error) {
                $('#form-errors').show();
                self.buttonEnabled = false;
                errorText.textContent = event.error.message;
              } else {
                $('#form-errors').hide();
                errorText.textContent = '';
                self.buttonEnabled = true;
              }
            });

            $('#submit').click(function (e) {
              e.preventDefault();
              self.payWithCard(stripe, card, response.data.clientSecret);
            });
          });
    },
    methods: {
      showPaymentForm() {
        document.querySelector("button#submit").disabled = true;
        this.selectedPaymentMethod = null;
        this.buttonEnabled = false;
        this.showForm = true;
      },
      selectCard(paymentMethodId) {
        this.showForm = false;
        this.cardElement.clear();
        this.selectedPaymentMethod = paymentMethodId;
        document.querySelector("button#submit").disabled = false;
        this.buttonEnabled = true;
      },
      loading(isLoading) {
        if (isLoading) {
          document.querySelector("button#submit").disabled = true;
          $("#processing-text").show();
          $("#button-text").hide();
        } else {
          document.querySelector("button#submit").disabled = false;
          $("#processing-text").hide();
          $("#button-text").show();
        }
      },
      showError(errorMsgText) {
        this.loading(false);
        let errorMsg = $("#form-errors");
        this.selectedPaymentMethod = null;
        if (this.showBackButton === true) {
          this.showForm = false;
          document.querySelector("button#submit").disabled = true;
        }

        errorMsg.show();
        $('#error-text').text(errorMsgText);
        setTimeout(function () {
          errorMsg
              .hide();
          $('#error-text').text('');
        }, 6000);
      },
      completePayment(paymentIntentId, message) {
        this.$emit('paymentComplete', message);
        if (this.redirectPath) {
          window.location = this.redirectPath + `?poid=${paymentIntentId}`;
        }
      },
      payWithCard(stripe, card, clientSecret) {
        this.loading(true);
        this.disabledBack(true);

        let self = this;

        let paymentMethodToUse = self.selectedPaymentMethod ? self.selectedPaymentMethod : {card: card};

        stripe.confirmCardPayment(clientSecret, {
          payment_method: paymentMethodToUse,
          setup_future_usage: self.storePaymentMethod ? 'on_session' : null,
        }).then(function (result) {
          if (result.error) {
            self.showError(result.error.message);
            self.disabledBack(false);
          } else {
            self.verifyPayment(result.paymentIntent.id);
            self.$emit('verify-payment');
          }
        });
      },
      verifyPayment(tdeskPaymentIntentId) {
        this.attempts++;

        if (this.attempts >= this.maxAttempts) {
          this.disabledBack(false);

          return;
        }

        let self = this;

        axios.get(`/verify_payment?poid=${tdeskPaymentIntentId}`)
          .then(function (response) {
            if (response.status === 200) {
              document.querySelector("button#submit").disabled = false;
              self.completePayment(response.data.poid, response.data.message);
            }
          }).catch(function (error) {
            self.handlePaymentError(error, tdeskPaymentIntentId);
            self.selectedPaymentMethod = null;
            self.showForm = false;
            document.querySelector("button#submit").disabled = true;
          });
      },
      handlePaymentError(error, tdeskPaymentIntentId) {
        if (!error.response) {
          return;
        }

        if (error.response.status === 502) {
          setTimeout(() => this.verifyPayment(tdeskPaymentIntentId), 1000);
        } else if (error.response.status !== 200) {
          setTimeout(() => this.verifyPayment(tdeskPaymentIntentId), 1000);
        }
      },
      disabledBack: function(flag) {
        const backBtn = document.querySelector('#stripe-back-btn');

        if (backBtn) { backBtn.disabled = flag; }
      },
    },
  };
</script>
